import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core';
import type { SpecificationConfirmDisclosureState } from '../../types/specification-confirm-disclosure';
import type { SpecificationConfirmDisclosureModel } from '../specification-confirm-disclosure-model';

@injectable()
export class SpecificationConfirmDisclosureModelImpl extends AbstractModel<SpecificationConfirmDisclosureState> implements SpecificationConfirmDisclosureModel {
    protected _modelData: SpecificationConfirmDisclosureState = {
        taskId: '',
        loading: false,
        loadingSubmit: false,
        formData: {
            classification: {
                content: [],
                status: null,
            },
            statutoryCategory: {
                content: '',
                status: null,
            },
            technicalQuestion: {
                content: '',
                status: null,
            },
            technicalSolution: {
                content: '',
                status: null,
            },
            technicalBenefit: {
                content: '',
                status: null,
            },
            embodiments: {
                content: [],
                status: null,
            },
        },
        formErrors: {},
    };

    get modelData(): SpecificationConfirmDisclosureState {
        return this._modelData;
    }
}
